<template>
  <div class="setting-main-container customization">
    <div class="card setting-card">
      <ul class="tabs">
        <li class="tab" v-for="(tap, index) in taps" :key="index" @click="setActiveTab(tap.tab_name)">
          <a :class="['tab-link', {'a-active': activeTab === tap.tab_name}]" href="#">
            {{ $t(tap.title) }}
          </a>
        </li>
      </ul>
      <!-- PurchaseOrders Tab -->
      <transition name="fade-customize">
        <div v-if="activeTab === 'PURCHASEORDERS'" class="purchaseOrder-tab">
          <form action="" class="mt-3" @submit.prevent="updatePurchaseOrderSetting">
            <div class="row">
              <div class="col-md-12 mb-4">
                <label class="input-label">{{ $t('settings.customization.purchaseOrders.purchase_order_prefix') }}</label>
                <base-input
                  v-model="purchaseOrders.purchase_order_prefix"
                  :invalid="$v.purchaseOrders.purchase_order_prefix.$error"
                  class="prefix-input"
                  @input="$v.purchaseOrders.purchase_order_prefix.$touch()"
                  @keyup="changeToUppercase('PURCHASEORDERS')"
                />
                <span v-show="!$v.purchaseOrders.purchase_order_prefix.required" class="text-danger mt-1">{{ $t('validation.required') }}</span>
                <span v-if="!$v.purchaseOrders.purchase_order_prefix.maxLength" class="text-danger">{{ $t('validation.prefix_maxlength') }}</span>
                <span v-if="!$v.purchaseOrders.purchase_order_prefix.alpha" class="text-danger">{{ $t('validation.characters_only') }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-12">
                <base-button
                  icon="save"
                  color="theme"
                  type="submit"
                >
                  {{ $t('settings.customization.save') }}
                </base-button>
              </div>
            </div>
          </form>

        </div>
      </transition>
      <!-- DeliveryNotes Tab -->
      <transition name="fade-customize">
        <div v-if="activeTab === 'DELIVERYNOTES'" class="deliveryNote-tab">
          <form action="" class="mt-3" @submit.prevent="updateDeliveryNoteSetting">
            <div class="row">
              <div class="col-md-12 mb-4">
                <label class="input-label">{{ $t('settings.customization.deliveryNotes.delivery_note_prefix') }}</label>
                <base-input
                  v-model="deliveryNotes.delivery_note_prefix"
                  :invalid="$v.deliveryNotes.delivery_note_prefix.$error"
                  class="prefix-input"
                  @input="$v.deliveryNotes.delivery_note_prefix.$touch()"
                  @keyup="changeToUppercase('DELIVERYNOTES')"
                />
                <span v-show="!$v.deliveryNotes.delivery_note_prefix.required" class="text-danger mt-1">{{ $t('validation.required') }}</span>
                <span v-if="!$v.deliveryNotes.delivery_note_prefix.maxLength" class="text-danger">{{ $t('validation.prefix_maxlength') }}</span>
                <span v-if="!$v.deliveryNotes.delivery_note_prefix.alpha" class="text-danger">{{ $t('validation.characters_only') }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-12">
                <base-button
                  icon="save"
                  color="theme"
                  type="submit"
                >
                  {{ $t('settings.customization.save') }}
                </base-button>
              </div>
            </div>
          </form>

        </div>
      </transition>
      <!-- Invoices Tab -->
      <transition name="fade-customize">
        <div v-if="activeTab === 'INVOICES'" class="invoice-tab">
          <form action="" class="mt-3" @submit.prevent="updateInvoiceSetting">
            <div class="row">
              <div class="col-md-12 mb-4">
                <label class="input-label">{{ $t('settings.customization.invoices.invoice_prefix') }}</label>
                <base-input
                  v-model="invoices.invoice_prefix"
                  :invalid="$v.invoices.invoice_prefix.$error"
                  class="prefix-input"
                  @input="$v.invoices.invoice_prefix.$touch()"
                  @keyup="changeToUppercase('INVOICES')"
                />
                <span v-show="!$v.invoices.invoice_prefix.required" class="text-danger mt-1">{{ $t('validation.required') }}</span>
                <span v-if="!$v.invoices.invoice_prefix.maxLength" class="text-danger">{{ $t('validation.prefix_maxlength') }}</span>
                <span v-if="!$v.invoices.invoice_prefix.alpha" class="text-danger">{{ $t('validation.characters_only') }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-12">
                <base-button
                  icon="save"
                  color="theme"
                  type="submit"
                >
                  {{ $t('settings.customization.save') }}
                </base-button>
              </div>
            </div>
          </form>
        </div>
      </transition>

      <!-- Preappoved Invoices Tab -->
      <transition name="fade-customize">
        <div v-if="activeTab === 'PREAPPROVEDINVOICES'" class="invoice-tab">
          <form action="" class="mt-3" @submit.prevent="updatePreapprovedInvoiceSetting">
            <div class="row">
              <div class="col-md-12 mb-4">
                <label class="input-label">{{ $t('settings.customization.preappoved_invoices.invoice_prefix') }}</label>
                <base-input
                  v-model="preapproved_invoices.preapproved_invoice_prefix"
                  :invalid="$v.preapproved_invoices.preapproved_invoice_prefix.$error"
                  class="prefix-input"
                  @input="$v.preapproved_invoices.preapproved_invoice_prefix.$touch()"
                  @keyup="changeToUppercase('PREAPPROVEDINVOICES')"
                />
                <span v-show="!$v.preapproved_invoices.preapproved_invoice_prefix.required" class="text-danger mt-1">{{ $t('validation.required') }}</span>
                <span v-if="!$v.preapproved_invoices.preapproved_invoice_prefix.maxLength" class="text-danger">{{ $t('validation.prefix_maxlength') }}</span>
                <span v-if="!$v.preapproved_invoices.preapproved_invoice_prefix.alpha" class="text-danger">{{ $t('validation.characters_only') }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-12">
                <base-button
                  icon="save"
                  color="theme"
                  type="submit"
                >
                  {{ $t('settings.customization.save') }}
                </base-button>
              </div>
            </div>
          </form>
        </div>
      </transition>

      <!-- Estimates Tab -->
      <transition name="fade-customize">
        <div v-if="activeTab === 'ESTIMATES'" class="estimate-tab">
          <form action="" class="mt-3" @submit.prevent="updateEstimateSetting">
            <div class="row">
              <div class="col-md-12 mb-4">
                <label class="input-label">{{ $t('settings.customization.estimates.estimate_prefix') }}</label>
                <base-input
                  v-model="estimates.estimate_prefix"
                  :invalid="$v.estimates.estimate_prefix.$error"
                  class="prefix-input"
                  @input="$v.estimates.estimate_prefix.$touch()"
                  @keyup="changeToUppercase('ESTIMATES')"
                />
                <span v-show="!$v.estimates.estimate_prefix.required" class="text-danger mt-1">{{ $t('validation.required') }}</span>
                <span v-if="!$v.estimates.estimate_prefix.maxLength" class="text-danger">{{ $t('validation.prefix_maxlength') }}</span>
                <span v-if="!$v.estimates.estimate_prefix.alpha" class="text-danger">{{ $t('validation.characters_only') }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-12">
                <base-button
                  icon="save"
                  color="theme"
                  type="submit"
                >
                  {{ $t('settings.customization.save') }}
                </base-button>
              </div>
            </div>
          </form>
        </div>
      </transition>

      <!-- Payments Tab -->
      <transition name="fade-customize">
        <div v-if="activeTab === 'PAYMENTS'" class="payment-tab">
          <div class="page-header">
            <div class="row">
              <div class="col-md-8">
                <!-- <h3 class="page-title">
                  {{ $t('settings.customization.payments.payment_mode') }}
                </h3> -->
              </div>
              <div class="col-md-4 d-flex flex-row-reverse">
                <base-button
                  outline
                  class="add-new-tax"
                  color="theme"
                  @click="addPaymentMode"
                >
                  {{ $t('settings.customization.payments.add_payment_mode') }}
                </base-button>
              </div>
            </div>
          </div>
          <table-component
            ref="table"
            :show-filter="false"
            :data="paymentModes"
            table-class="table tax-table"
            class="mb-3"
          >
            <table-column
              :sortable="true"
              :label="$t('settings.customization.payments.payment_mode')"
              show="name"
            />
            <table-column
              :sortable="false"
              :filterable="false"
              cell-class="action-dropdown"
            >
              <template slot-scope="row">
                <span>{{ $t('settings.tax_types.action') }}</span>
                <v-dropdown>
                  <a slot="activator" href="#">
                    <dot-icon />
                  </a>
                  <v-dropdown-item>
                    <div class="dropdown-item" @click="editPaymentMode(row)">
                      <font-awesome-icon :icon="['fas', 'pencil-alt']" class="dropdown-item-icon" />
                      {{ $t('general.edit') }}
                    </div>
                  </v-dropdown-item>
                  <v-dropdown-item>
                    <div class="dropdown-item" @click="removePaymentMode(row.id)">
                      <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
                      {{ $t('general.delete') }}
                    </div>
                  </v-dropdown-item>
                </v-dropdown>
              </template>
            </table-column>
          </table-component>
          <hr>
          <form action="" class="pt-3" @submit.prevent="updatePaymentSetting">
            <div class="row">
              <div class="col-md-12 mb-4">
                <label class="input-label">{{ $t('settings.customization.payments.payment_prefix') }}</label>
                <base-input
                  v-model="payments.payment_prefix"
                  :invalid="$v.payments.payment_prefix.$error"
                  class="prefix-input"
                  @input="$v.payments.payment_prefix.$touch()"
                  @keyup="changeToUppercase('PAYMENTS')"
                />
                <span v-show="!$v.payments.payment_prefix.required" class="text-danger mt-1">{{ $t('validation.required') }}</span>
                <span v-if="!$v.payments.payment_prefix.maxLength" class="text-danger">{{ $t('validation.prefix_maxlength') }}</span>
                <span v-if="!$v.payments.payment_prefix.alpha" class="text-danger">{{ $t('validation.characters_only') }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-12">
                <base-button
                  icon="save"
                  color="theme"
                  type="submit"
                >
                  {{ $t('settings.customization.save') }}
                </base-button>
              </div>
            </div>
          </form>
        </div>
      </transition>

      <!-- Items Tab -->
      <transition name="fade-customize">
        <div v-if="activeTab === 'ITEMS'" class="item-tab">
          <div class="page-header">
            <div class="row">
              <div class="col-md-8">
                <!-- <h3 class="page-title">
                  {{ $t('settings.customization.items.title') }}
                </h3> -->
              </div>
              <div class="col-md-4 d-flex flex-row-reverse">
                <base-button
                  outline
                  class="add-new-tax"
                  color="theme"
                  @click="addItemUnit"
                >
                  {{ $t('settings.customization.items.add_item_unit') }}
                </base-button>
              </div>
            </div>
          </div>
          <table-component
            ref="itemTable"
            :show-filter="false"
            :data="itemUnits"
            table-class="table tax-table"
            class="mb-3"
          >
            <table-column
              :sortable="true"
              :label="$t('settings.customization.items.units')"
              show="name"
            />
            <table-column
              :sortable="false"
              :filterable="false"
              cell-class="action-dropdown"
            >
              <template slot-scope="row">
                <span>{{ $t('settings.tax_types.action') }}</span>
                <v-dropdown>
                  <a slot="activator" href="#">
                    <dot-icon />
                  </a>
                  <v-dropdown-item>
                    <div class="dropdown-item" @click="editItemUnit(row)">
                      <font-awesome-icon :icon="['fas', 'pencil-alt']" class="dropdown-item-icon" />
                      {{ $t('general.edit') }}
                    </div>
                  </v-dropdown-item>
                  <v-dropdown-item>
                    <div class="dropdown-item" @click="removeItemUnit(row.id)">
                      <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
                      {{ $t('general.delete') }}
                    </div>
                  </v-dropdown-item>
                </v-dropdown>
              </template>
            </table-column>
          </table-component>
        </div>
      </transition>

    </div>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
const { required, maxLength, alpha } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      activeTab: '',
      purchaseOrderAutogenerate: false,
      deliveryNoteAutogenerate: false,
      invoiceAutogenerate: false,
      estimateAutogenerate: false,
      paymentAutogenerate: false,
      purchaseOrders: {
        purchase_order_prefix: null,
        purchase_order_notes: null,
        purchase_order_terms_and_conditions: null
      },
      deliveryNotes: {
        delivery_note_prefix: null,
        delivery_note_notes: null,
        delivery_note_terms_and_conditions: null
      },
      invoices: {
        invoice_prefix: null,
        invoice_notes: null,
        invoice_terms_and_conditions: null
      },
      preapproved_invoices: {
        preapproved_invoice_prefix: null
      },
      estimates: {
        estimate_prefix: null,
        estimate_notes: null,
        estimate_terms_and_conditions: null
      },
      payments: {
        payment_prefix: null
      },
      items: {
        units: []
      },
      currentData: null,
      supplier_taps: [
        {
          tab_name: 'DELIVERYNOTES',
          title: 'settings.customization.deliveryNotes.title'
        },
        {
          tab_name: 'INVOICES',
          title: 'settings.customization.invoices.title'
        },
        {
          tab_name: 'PAYMENTS',
          title: 'settings.customization.payments.title'
        },
        {
          tab_name: 'ITEMS',
          title: 'settings.customization.items.title'
        }
      ],
      anchor_taps: [
        {
          tab_name: 'PURCHASEORDERS',
          title: 'settings.customization.purchaseOrders.title'
        },
        {
          tab_name: 'PREAPPROVEDINVOICES',
          title: 'settings.customization.preappoved_invoices.title'
        },
        {
          tab_name: 'PAYMENTS',
          title: 'settings.customization.payments.title'
        }
      ],
      funder_taps: [
        {
          tab_name: 'PAYMENTS',
          title: 'settings.customization.payments.title'
        }
      ],
      taps: null
    }
  },
  computed: {
    ...mapGetters('item', [
      'itemUnits'
    ]),
    ...mapGetters('payment', [
      'paymentModes'
    ])
  },
  watch: {
    activeTab () {
      this.loadData()
    }
  },
  validations: {
    purchaseOrders: {
      purchase_order_prefix: {
        required,
        maxLength: maxLength(5),
        alpha
      }
    },
    deliveryNotes: {
      delivery_note_prefix: {
        required,
        maxLength: maxLength(5),
        alpha
      }
    },
    invoices: {
      invoice_prefix: {
        required,
        maxLength: maxLength(5),
        alpha
      }
    },
    preapproved_invoices: {
      preapproved_invoice_prefix: {
        required,
        maxLength: maxLength(5),
        alpha
      }
    },
    estimates: {
      estimate_prefix: {
        required,
        maxLength: maxLength(5),
        alpha
      }
    },
    payments: {
      payment_prefix: {
        required,
        maxLength: maxLength(5),
        alpha
      },
      userType: null
    }

  },
  created () {
    if (localStorage.getItem('role') === 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') === 'anchor') {
      this.userType = 'anchor'
      this.taps = this.anchor_taps
      this.activeTab = 'PURCHASEORDERS'
    } else if (localStorage.getItem('account_type') === '=funder') {
      this.userType = 'funder'
      this.taps = this.funder_taps
      this.activeTab = 'PAYMENTS'
    } else if (localStorage.getItem('account_type') === 'supplier') {
      this.userType = 'supplier'
      this.taps = this.supplier_taps
      this.activeTab = 'DELIVERYNOTES'
    }

    this.loadData()
  },
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('payment', [
      'deletePaymentMode'
    ]),
    ...mapActions('item', [
      'deleteItemUnit'
    ]),
    async addItemUnit () {
      this.openModal({
        'title': 'Add Item Unit',
        'componentName': 'ItemUnit'
      })
      this.$refs.itemTable.refresh()
    },
    async editItemUnit (data) {
      this.openModal({
        'title': 'Edit Item Unit',
        'componentName': 'ItemUnit',
        'id': data.id,
        'data': data
      })
      this.$refs.itemTable.refresh()
    },
    async removeItemUnit (id) {
      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$t('settings.customization.items.item_unit_confirm_delete'),
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (value) => {
        if (value) {
          let response = await this.deleteItemUnit(id)
          if (response.data.success) {
            window.toastr['success'](this.$t('settings.customization.items.deleted_message'))
            this.id = null
            this.$refs.itemTable.refresh()
            return true
          }
          window.toastr['error'](this.$t('settings.customization.items.already_in_use'))
        }
      })
    },
    async addPaymentMode () {
      this.openModal({
        'title': 'Add Payment Mode',
        'componentName': 'PaymentMode'
      })
      this.$refs.table.refresh()
    },
    async editPaymentMode (data) {
      this.openModal({
        'title': 'Edit Payment Mode',
        'componentName': 'PaymentMode',
        'id': data.id,
        'data': data
      })
      this.$refs.table.refresh()
    },
    removePaymentMode (id) {
      swal({
        title: this.$t('general.are_you_sure'),
        text: this.$t('settings.customization.payments.payment_mode_confirm_delete'),
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (value) => {
        if (value) {
          let response = await this.deletePaymentMode(id)
          if (response.data.success) {
            window.toastr['success'](this.$t('settings.customization.payments.deleted_message'))
            this.id = null
            this.$refs.table.refresh()
            return true
          }
          window.toastr['error'](this.$t('settings.customization.payments.already_in_use'))
        }
      })
    },
    changeToUppercase (currentTab) {
      if (currentTab === 'PURCHASEORDERS') {
        this.purchaseOrders.purchase_order_prefix = this.purchaseOrders.purchase_order_prefix.toUpperCase()
        return true
      }
      if (currentTab === 'DELIVERYNOTES') {
        this.deliveryNotes.delivery_note_prefix = this.deliveryNotes.delivery_note_prefix.toUpperCase()
        return true
      }
      if (currentTab === 'INVOICES') {
        this.invoices.invoice_prefix = this.invoices.invoice_prefix.toUpperCase()
        return true
      }
      if (currentTab === 'PREAPPROVEDINVOICES') {
        this.preapproved_invoices.preapproved_invoice_prefix = this.preapproved_invoices.preapproved_invoice_prefix.toUpperCase()
        return true
      }

      if (currentTab === 'ESTIMATES') {
        this.estimates.estimate_prefix = this.estimates.estimate_prefix.toUpperCase()
        return true
      }

      if (currentTab === 'PAYMENTS') {
        this.payments.payment_prefix = this.payments.payment_prefix.toUpperCase()
        return true
      }
    },
    async loadData () {
      let res = await window.axios.get('/api/settings/get-customize-setting')

      if (res.data) {
        this.purchaseOrders.purchase_order_prefix = res.data.purchase_order_prefix
        this.purchaseOrders.purchase_order_notes = res.data.purchase_order_notes
        this.purchaseOrders.purchase_order_terms_and_conditions = res.data.purchase_order_terms_and_conditions

        this.deliveryNotes.delivery_note_prefix = res.data.delivery_note_prefix
        this.deliveryNotes.delivery_note_notes = res.data.delivery_note_notes
        this.deliveryNotes.delivery_note_terms_and_conditions = res.data.delivery_note_terms_and_conditions

        this.invoices.invoice_prefix = res.data.invoice_prefix
        this.invoices.invoice_notes = res.data.invoice_notes
        this.invoices.invoice_terms_and_conditions = res.data.invoice_terms_and_conditions

        this.preapproved_invoices.preapproved_invoice_prefix = res.data.preapproved_invoice_prefix


        this.estimates.estimate_prefix = res.data.estimate_prefix
        this.estimates.estimate_notes = res.data.estimate_notes
        this.estimates.estimate_terms_and_conditions = res.data.estimate_terms_and_conditions
        this.payments.payment_prefix = res.data.payment_prefix
        if (res.data.purchase_order_auto_generate === 'YES') {
          this.purchaseOrderAutogenerate = true
        } else {
          this.purchaseOrderAutogenerate = false
        }
        if (res.data.delivery_note_auto_generate === 'YES') {
          this.deliveryNoteAutogenerate = true
        } else {
          this.deliveryNoteAutogenerate = false
        }
        if (res.data.invoice_auto_generate === 'YES') {
          this.invoiceAutogenerate = true
        } else {
          this.invoiceAutogenerate = false
        }

        if (res.data.estimate_auto_generate === 'YES') {
          this.estimateAutogenerate = true
        } else {
          this.estimateAutogenerate = false
        }

        if (res.data.payment_auto_generate === 'YES') {
          this.paymentAutogenerate = true
        } else {
          this.paymentAutogenerate = false
        }
      }
    },
    async updatePurchaseOrderSetting () {
      this.$v.purchaseOrders.$touch()

      if (this.$v.purchaseOrders.$invalid) {
        return false
      }

      let data = {type: 'PURCHASEORDERS', ...this.purchaseOrders}

      if (this.updateSetting(data)) {
        window.toastr['success'](this.$t('settings.customization.purchaseOrders.purchase_order_setting_updated'))
      }
    },
    async updateDeliveryNoteSetting () {
      this.$v.deliveryNotes.$touch()

      if (this.$v.deliveryNotes.$invalid) {
        return false
      }

      let data = {type: 'DELIVERYNOTES', ...this.deliveryNotes}
      console.log(data)

      if (this.updateSetting(data)) {
        window.toastr['success'](this.$t('settings.customization.deliveryNotes.delivery_note_setting_updated'))
      }
    },
    async updateInvoiceSetting () {
      this.$v.invoices.$touch()

      if (this.$v.invoices.$invalid) {
        return false
      }

      let data = {type: 'INVOICES', ...this.invoices}

      if (this.updateSetting(data)) {
        window.toastr['success'](this.$t('settings.customization.invoices.invoice_setting_updated'))
      }
    },
    async updatePreapprovedInvoiceSetting () {
      this.$v.preapproved_invoices.$touch()

      if (this.$v.preapproved_invoices.$invalid) {
        return false
      }

      let data = {type: 'PREAPPROVEDINVOICES', ...this.preapproved_invoices}

      if (this.updateSetting(data)) {
        window.toastr['success'](this.$t('settings.customization.preappoved_invoices.invoice_setting_updated'))
      }
    },
    async updateEstimateSetting () {
      this.$v.estimates.$touch()

      if (this.$v.estimates.$invalid) {
        return false
      }

      let data = {type: 'ESTIMATES', ...this.estimates}

      if (this.updateSetting(data)) {
        window.toastr['success'](this.$t('settings.customization.estimates.estimate_setting_updated'))
      }
    },
    async updatePaymentSetting () {
      this.$v.payments.payment_prefix.$touch()

      if (this.$v.payments.payment_prefix.$invalid) {
        return false
      }

      let data = {type: 'PAYMENTS', ...this.payments}

      if (this.updateSetting(data)) {
        window.toastr['success'](this.$t('settings.customization.payments.payment_setting_updated'))
      }
    },
    async updateSetting (data) {
      console.log(data)
      let res = await window.axios.put('/api/settings/update-customize-setting', data)

      if (res.data.success) {
        return true
      }

      return false
    },
    setActiveTab (val) {
      this.activeTab = val
    }
  }
}
</script>
<style>
  .fade-customize-enter-active {
    transition: opacity 0.9s;
  }

  .fade-customize-leave-active  {
    transition: opacity 0s;
  }

  .fade-customize-enter, .fade-customize-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
